// @ts-ignore
/* eslint-disable */
import request from "../../request";

/** 批量获取多个字典类型及其值 GET /apiAdmin/dict/batch */
export async function dictControllerGetDictTypesByCodesWithValues(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.DictControllerGetDictTypesByCodesWithValuesParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataDictTypeWithValuesDtoArrayDto>(
    "/apiAdmin/dict/batch",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建字典类型 POST /apiAdmin/dict/types */
export async function dictControllerCreateDictType(
  body: API.CreateDictTypeDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataDictTypeDataDtoDto>("/apiAdmin/dict/types", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 根据编码获取字典类型 GET /apiAdmin/dict/types/${param0} */
export async function dictControllerGetDictTypeByCode(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.DictControllerGetDictTypeByCodeParams,
  options?: { [key: string]: any }
) {
  const { codeField: param0, ...queryParams } = params;
  return request<API.ResultDataDictTypeDataDtoDto>(
    `/apiAdmin/dict/types/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新字典类型 PUT /apiAdmin/dict/types/${param0} */
export async function dictControllerUpdateDictType(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.DictControllerUpdateDictTypeParams,
  body: API.UpdateDictTypeDto,
  options?: { [key: string]: any }
) {
  const { codeField: param0, ...queryParams } = params;
  return request<API.ResultDataDictTypeDataDtoDto>(
    `/apiAdmin/dict/types/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除字典类型 DELETE /apiAdmin/dict/types/${param0} */
export async function dictControllerDeleteDictType(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.DictControllerDeleteDictTypeParams,
  options?: { [key: string]: any }
) {
  const { codeField: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/dict/types/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 获取所有字典类型 POST /apiAdmin/dict/types/list */
export async function dictControllerGetDictTypes(options?: {
  [key: string]: any;
}) {
  return request<API.ResultDataDictTypeDataDtoArrayDto>(
    "/apiAdmin/dict/types/list",
    {
      method: "POST",
      ...(options || {}),
    }
  );
}

/** 创建字典值 POST /apiAdmin/dict/values */
export async function dictControllerCreateDictValue(
  body: API.CreateDictValueDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataDictValueDataDtoDto>("/apiAdmin/dict/values", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 根据字典编码获取字典值列表 GET /apiAdmin/dict/values/${param0} */
export async function dictControllerGetDictValuesByCode(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.DictControllerGetDictValuesByCodeParams,
  options?: { [key: string]: any }
) {
  const { codeField: param0, ...queryParams } = params;
  return request<API.ResultDataDictValueDataDtoArrayDto>(
    `/apiAdmin/dict/values/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新字典值 PUT /apiAdmin/dict/values/${param0} */
export async function dictControllerUpdateDictValue(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.DictControllerUpdateDictValueParams,
  body: API.UpdateDictValueDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultDataDictValueDataDtoDto>(
    `/apiAdmin/dict/values/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除字典值 DELETE /apiAdmin/dict/values/${param0} */
export async function dictControllerDeleteDictValue(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.DictControllerDeleteDictValueParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/dict/values/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 获取字典类型及其值 GET /apiAdmin/dict/withValues/${param0} */
export async function dictControllerGetDictTypeWithValues(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.DictControllerGetDictTypeWithValuesParams,
  options?: { [key: string]: any }
) {
  const { codeField: param0, ...queryParams } = params;
  return request<API.ResultDataDictTypeWithValuesDtoDto>(
    `/apiAdmin/dict/withValues/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
